import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=24842da9&scoped=true&"
import script from "./TableFooter.vue?vue&type=script&lang=js&"
export * from "./TableFooter.vue?vue&type=script&lang=js&"
import style0 from "./TableFooter.vue?vue&type=style&index=0&id=24842da9&prod&scoped=true&lang=css&"
import style1 from "./TableFooter.vue?vue&type=style&index=1&id=24842da9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24842da9",
  null
  
)

export default component.exports